const state = {
  token: sessionStorage.getItem('token'),
  tokentime: sessionStorage.getItem('tokentime'),
  userProfileInfo: JSON.parse(sessionStorage.getItem('userProfileInfo'))
}
const mutations = {
  set_token(state, data) {
    state.token = data
    sessionStorage.setItem('token', data)
  },
  set_tokentime(state, data) {
    state.tokenTime = data
    sessionStorage.setItem('tokentime', data)
  },
  set_userProfileInfo(state, data) {
    state.userProfileInfo = data
    sessionStorage.setItem('userProfileInfo', JSON.stringify(data))
  }
  // set_userinfo(state, userinfo) {
  //   state.userinfo = userinfo
  //   sessionStorage.setItem('userinfo', JSON.stringify(userinfo))
  // }
}
const actions = {
  // async signOut({ commit }) {
  //   commit('set_token', '')
  // }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js